import Block from "quill/blots/block";
import Embed from 'quill/blots/embed';
import {FileIcons} from "../../InputChat/FileIcons";
import unknown_svg from "../../../../assets/FileIcons/unknown.svg";

class FileBlotCustom extends Embed {
    static blotName = 'fileUpload';
    static tagName = 'div';
    static className = 'file-custom';

    static create(value: { name: string; url: string }) {
        let node = super.create() as HTMLElement;
        try {
            let fileTypeGet = value.name.split(".");
            let imgGet = this.fileIcon(fileTypeGet[fileTypeGet.length - 1]);
            node.innerHTML = `
                    <img src="${imgGet}" style="max-width: 100px; max-height: 100px;"/>
                    <a class="ql-file-upload" href="${value.url}">${value.name}</a>
            `;
            return node;
        } catch (e) {
            console.error(e);
            return node;
        }
    }


    static value(node: HTMLElement) {
        const img = node.querySelector('img');
        const a = node.querySelector('a');
        if (img && a) {
            return {
                url: a.href,
                name: a.innerText
            };
        }
        return null;
    }


    static fileIcon(fileType: string | undefined) {
        let fileTypeClean = fileType?.replace(/\./g, "");
        let variableName = `${fileTypeClean}_svg`;
        let pictureSrc = (FileIcons as any)[variableName];
        if (!pictureSrc) {
            return unknown_svg;
        } else {
            return pictureSrc;
        }
    }
}

export default FileBlotCustom;